<nz-segmented
  [nzDisabled]="disabled"
  [nzLabelTemplate]="labelTemplate"
  [nzOptions]="options"
  [nzSize]="size"
  [(ngModel)]="selectedIndex"
  (ngModelChange)="handleModelChange($event)"
></nz-segmented>
<ng-template #labelTemplate let-index="index" let-option>
  @if (enableAnalytics) {
    <span [elementCustomId]="option.analyticsElementCustomId" appTrackClick>
      <ng-container [ngTemplateOutlet]="labelValue"></ng-container>
    </span>
  } @else {
    <ng-container [ngTemplateOutlet]="labelValue"></ng-container>
  }
  <ng-template #labelValue>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px">
      @if (showCheckIcon && selectedIndex === index) {
        <mat-icon [@fadeInEnter] class="color-blue md-16"
          >check_circle
        </mat-icon>
      }
      <span
        [ngClass]="{
          'color-blue': selectedIndex === index,
        }"
        [ngStyle]="{ fontSize: '13px' }"
      >
        {{ option.label }}
      </span>
    </div>
  </ng-template>
</ng-template>
